import { useEffect } from 'react';
import type { Control } from 'react-hook-form';
import { useFormState } from 'react-hook-form';

export function useScrollToFormError(control: Control, formId: string) {
  const { errors } = useFormState({ control });

  useEffect(() => {
    const errorKeys = Object.keys(errors);
    const firstKey = errorKeys[0];
    let scrollToKey = firstKey;

    if (!firstKey || !errorKeys || !errorKeys.length) return;

    if (Array.isArray(errors[firstKey]) && errors[firstKey][0]) {
      const childErrorKeys = Object.keys(errors[firstKey][0]);
      scrollToKey = `${firstKey}.0.${childErrorKeys[0]}`;
    }

    const errorElement = document
      .getElementById(`${formId}`)
      ?.querySelector(`[name="${scrollToKey}"]`);
    if (!errorElement) return;

    errorElement.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'center',
    });
  }, [errors, formId]);
}
